import { Lyric } from './src/Lyric'
export { Lyric }
export default Lyric



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/components/Lyric/index.ts